import React, { useEffect, createContext, useState } from 'react';

export const AuthContext = createContext({
  isAuthenticated: null, // 초기 상태 null (로딩 중)
  user: null,
  setAuthenticated: () => {},
  setUser: () => {}
});

export const AuthProvider = ({ children }) => {
  // 인증상태 저장
  const [isAuthenticated, setAuthenticated] = useState(null);
  // 유저 정보 저장
  const [user, setUser] = useState(null);

  useEffect(() => {
    // 백엔드 세션 확인 API 호출 (세션 쿠키 전달을 위해 credentials: 'include' 사용)
    fetch('/api/check-session', { credentials: 'include' })
      .then((response) => {
        if (!response.ok) {
          throw new Error('세션 확인 실패');
        }
        return response.json();
      })
      .then((data) => {
        // 세션정보와 유저정보 상태 세팅
        setAuthenticated(data.authenticated);
        setUser(data.user);
      })
      .catch((error) => {
        console.error('인증 상태 확인 중 에러:', error);
        setAuthenticated(false);
        setUser(null);
      });
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setAuthenticated, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};